import React, { useState } from 'react';
import { Table, Container } from 'reactstrap';
import styles from './RecentOrderTable.module.scss';

const RecentOrderTable = ({ headers, data }) => {
    const [visibleRows, setVisibleRows] = useState(4);  // Show 5 rows initially

    const handleViewAll = () => {
        setVisibleRows(data.length);  // Show all rows on button click
    };

    const getStatusClass = (status) => {
        switch (status.toLowerCase()) {
            case 'pending':
                return styles.statusPending;
            case 'delivered':
                return styles.statusDelivered;
            case 'ready to ship':
                return styles.statusReady;
            default:
                return '';
        }
    };

    return (
        <Container fluid className={styles.recentOrderTable}>
            <Table hover>
                <thead>
                    <tr>
                        {headers.map((header, index) => (
                            <th key={index}>{header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {data.slice(0, visibleRows).map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            {row.map((cell, cellIndex) => (
                                <td key={cellIndex} className={cellIndex === 6 ? getStatusClass(cell) : ''}>
                                    {cellIndex === 0 ? (
                                        <img src={cell} alt="product" className={styles.productImage} />
                                    ) : cellIndex === 1 ? (
                                        <div className={styles.cellWithImageAndText}>
                                            <img src={cell.image} alt={cell.text} className={styles.customerImage} />
                                            <span>{cell.text}</span>
                                        </div>
                                    ) : (
                                        cell
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </Table>
            {visibleRows < data.length && (
                <button className={styles.viewAllButton} onClick={handleViewAll}>
                    View All Orders
                </button>
            )}
        </Container>
    );
};

export default RecentOrderTable;
